import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Header from "../components/headerfooter/Header";
import Footer from "../components/headerfooter/Footer";
import CallToAction from "../components/home/CallToAction";
import MobileFooter from "../components/MobileFooter";
import axios from "axios";
import { REACT_APP_API_PORT } from "../Api";
import Loader from "../components/Loader";
import { useNavigate } from "react-router";
import { IoIosRefreshCircle } from "react-icons/io";
import { Helmet } from "react-helmet";

const ContactUs = (props) => { 
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState([]);
  const [isLoading, setisLoading] = useState(false);

  const [captcha, setCaptcha] = useState("");
  const [userCaptcha, setUserCaptcha] = useState("");

  const getData = async () => {
    try {
      setisLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/contactus-page-details`
      );
      setisLoading(false);
      if (res.data.status) {
        setData(res.data.data);
      }
    } catch (err) {
      setisLoading(false);
      console.log(err);
    }
  };

  const fetchMetaData = async () => {
    try {
      setisLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/page-seo-details/Contactus Page`
      );
      if (res.data.status) {
        setMeta(res.data.data)
      }
    } catch (err) {
      console.error(err);
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    getData();
    generateCaptcha();
    fetchMetaData()
  }, []);

  const generateCaptcha = () => {
    const chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let code = "";
    for (let i = 0; i < 5; i++) {
      code += chars[Math.floor(Math.random() * chars.length)];
    }
    setCaptcha(code);
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phoneNumber: "",
      message: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      phoneNumber: Yup.string()
        .matches(/^((\+91|91)?[6789]\d{9})$/, "Invalid Indian phone number"),
      message: Yup.string().required("Message is required"),
    }),
    onSubmit: (values) => {
      // if (userCaptcha.trim().toLowerCase() !== captcha.trim().toLowerCase()) {
      if (userCaptcha.trim() !== captcha.trim()) {
        props.setAlertBox(true);
        props.showAlert("Invalid CAPTCHA. Please try again.", "error");
        generateCaptcha();
        return;
      }
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    try {
      setisLoading(true);
      const res = await axios.post(`${REACT_APP_API_PORT}user/frontend/user_contactus_request`, {
        name: values.name,
        email: values.email,
        phone: values.phoneNumber,
        message: values.message,
      });
      setisLoading(false);

      if (res.data.status) {
        props.setAlertBox(true);
        props.showAlert(res.data.message, "success");
      }
    } catch (err) {
      console.log(err);
      setisLoading(false);
      if (err.response?.data?.status === false) {
        props.setAlertBox(true);
        props.showAlert(err.response.data.message, "error");
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>{meta?.meta_title}</title>
        <meta name="description" content={meta?.meta_description} />
        <meta name="keywords" content={meta?.meta_keywords} />
      </Helmet>
      <Loader isLoading={isLoading} />
      {/* <TopBar /> */}
      <Header />
      <div className="relative bg-background-back1 py-12 pt-32">
        <div className="flex flex-col items-center justify-center gap-3 sm:gap-5 lg:gap-6 xl:gap-8">
          <div className="w-full">
            <div className="flex items-center justify-center gap-1 lg:gap-4">
              <div className="w-20 lg:w-24 h-[1px] bg-gradient-to-r from-transparent via-blue-500 to-transparent relative">
                <div className="absolute inset-0 blur-[2px] bg-gradient-to-r from-transparent via-blue-500 to-transparent"></div>
                <div className="absolute inset-0 blur-[4px] bg-gradient-to-r from-transparent via-blue-400/50 to-transparent"></div>
              </div>
              <span className="w-max text-sm sm:text-base lg:text-lg xl:text-xl text-[#959efe] font-light tracking-wider">
                {data?.heading1}
              </span>
              <div className="w-20 lg:w-24 h-[1px] bg-gradient-to-r from-transparent via-blue-500 to-transparent relative">
                <div className="absolute inset-0 blur-[2px] bg-gradient-to-r from-transparent via-blue-500 to-transparent"></div>
                <div className="absolute inset-0 blur-[4px] bg-gradient-to-r from-transparent via-blue-400/50 to-transparent"></div>
              </div>
            </div>
          </div>

          <div className="lg:w-[65%] w-full lg:px-0 px-2">
            <h1 className="lg:px-4 px-2 z-10 whitespace-pre-wrap text-center lg:text-3xl text-xl font-bold tracking-tighter text-white dark:text-white font-sans">
              {data?.heading2}
            </h1>

            <div
              className="text-sm lg:text-base xl:text-lg font-medium text-white dark:text-white px-5"
              dangerouslySetInnerHTML={{ __html: data?.description }}
            />

            <div className="p-6 py-5 px-5 bg-background-back2/30 rounded mt-5">
              <form className="space-y-6" onSubmit={formik.handleSubmit}>
                <div className="space-y-2">
                  <label className="text-sm font-medium text-white" htmlFor="name">
                    Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    className="flex h-10 w-full bg-[#1a1a1a] text-white shadow-input rounded-xl px-3 py-2"
                    placeholder="Your name"
                    id="name"
                    name="name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                  />
                  {formik.touched.name && formik.errors.name && (
                    <p className="text-red-500 text-sm">{formik.errors.name}</p>
                  )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <label className="text-sm font-medium text-white" htmlFor="email">
                      Email <span className="text-red-500">*</span>
                    </label>
                    <input
                      className="flex h-10 w-full bg-[#1a1a1a] text-white shadow-input rounded-xl px-3 py-2"
                      placeholder="yourname@example.com"
                      id="email"
                      name="email"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                    />
                    {formik.touched.email && formik.errors.email && (
                      <p className="text-red-500 text-sm">{formik.errors.email}</p>
                    )}
                  </div>

                  <div className="space-y-2">
                    <label className="text-sm font-medium text-white" htmlFor="phoneNumber">
                      Phone Number
                    </label>
                    <input
                      className="flex h-10 w-full bg-[#1a1a1a] text-white shadow-input rounded-xl px-3 py-2"
                      placeholder="Enter your number"
                      id="phoneNumber"
                      name="phoneNumber"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.phoneNumber}
                    />
                    {formik.touched.phoneNumber && formik.errors.phoneNumber && (
                      <p className="text-red-500 text-sm">{formik.errors.phoneNumber}</p>
                    )}
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-white" htmlFor="message">
                    Message <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    className="flex w-full bg-[#1a1a1a] text-white shadow-input rounded-xl px-3 py-2 resize-none"
                    placeholder="Your message"
                    id="message"
                    name="message"
                    rows="4"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.message}
                  />
                  {formik.touched.message && formik.errors.message && (
                    <p className="text-red-500 text-sm">{formik.errors.message}</p>
                  )}
                </div>

                {/* CAPTCHA Section */}
                <div className="space-y-2">
                  <label className="text-sm font-medium text-white">Captcha <span className="text-red-500">*</span></label>
                  <div className="flex items-center gap-4">
                    <div className="bg-[#1a1a1a] text-white px-4 py-2 rounded-xl font-mono tracking-widest select-none">
                      {captcha}
                    </div>
                    <button type="button" onClick={generateCaptcha} className="text-sm text-blue-400 hover:underline">
                      <IoIosRefreshCircle size={25} />
                    </button>
                  </div>
                  <input
                    className="flex h-10 w-full bg-[#1a1a1a] text-white shadow-input rounded-xl px-3 py-2"
                    placeholder="Enter captcha code"
                    value={userCaptcha}
                    onChange={(e) => setUserCaptcha(e.target.value)}
                  />
                </div>

                <button className="border-2 border-customBlue px-12 py-2 rounded text-white hover:bg-background-primary transition" type="submit">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <CallToAction />
      <Footer />
      <MobileFooter />
    </>
  );
};

export default ContactUs;
